import { createReducer, on } from "@ngrx/store";

import { BlackBoxEntry } from "src/model/class/general classes/black-box-entry";
import {
  blackBoxAddEntry,
  blackBoxRemoveAllEntry,
  blackBoxRemoveEntry,
} from "../actions/black-box.actions";

/**
 * Reducer for notifications
 */
export const BlackBoxReducer = createReducer(
  [],
  on(blackBoxAddEntry, (blackBoxObject: Array<BlackBoxEntry>, action) => {
    let newArray = blackBoxObject;
    let numMaxCalculated = action.numberEvents;
    numMaxCalculated--;
    if (blackBoxObject.length >= action.numberEvents) {
      const arraySliced = blackBoxObject.slice(
        blackBoxObject.length - numMaxCalculated
      );
      newArray = arraySliced;
    }
    return [...newArray, action.insertEntry];
  }),
  on(blackBoxRemoveEntry, (blackBoxObject: Array<BlackBoxEntry>, action) => {
    if (blackBoxObject.length > action.numberEvents) {
      const arraySliced = blackBoxObject.slice(
        blackBoxObject.length - action.numberEvents
      );
      return arraySliced;
    }
    return blackBoxObject;
  }),
  on(blackBoxRemoveAllEntry, (blackBoxObject: Array<BlackBoxEntry>, action) => {
    return [];
  })
);
